import {
  Button,
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  title: string;
  children: ReactNode;
  confirmLabel: string;
  onClose: () => void;
  onConfirm: () => void;
  cancelLabel?: string;
  confirmColor?: ButtonProps['color'];
  disabled?: boolean;
}

export const DashboardConfirmationDialog: FC<Props> = ({
  open,
  title,
  children,
  confirmLabel,
  onClose,
  onConfirm,
  cancelLabel,
  confirmColor = 'error',
  disabled = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">{children}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={onClose} disabled={disabled}>
          {cancelLabel ?? t('cancel', 'Cancel')}
        </Button>
        <Button variant="contained" color={confirmColor} onClick={onConfirm} disabled={disabled}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
